import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, route, hasRelatedData = false }) => {
  if (!isOpen || !route) return null;

  return (
    <div className="fixed inset-0 z-2000 flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="w-full max-w-md bg-card rounded-xl shadow-2xl overflow-hidden">
        <div className="p-6 space-y-4">
          <div className="flex items-center justify-center w-16 h-16 bg-destructive/10 rounded-full mx-auto">
            <Icon name="AlertTriangle" size={32} color="var(--color-destructive)" />
          </div>

          <div className="text-center space-y-2">
            <h2 className="text-xl font-bold text-foreground font-heading">
              Rotayı Sil
            </h2>
            <p className="text-muted-foreground">
              <span className="font-semibold text-foreground">{route?.route_name}</span> rotasını silmek istediğinizden emin misiniz?
            </p>
          </div>

          {hasRelatedData && (
            <div className="bg-warning/10 border border-warning/20 rounded-lg p-4">
              <div className="flex items-start gap-3">
                <Icon name="AlertCircle" size={20} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-warning mb-1">Uyarı</p>
                  <p className="text-xs text-muted-foreground">
                    Bu rota ile ilişkili geometri, durak ve sefer verileri de silinecektir. Bu işlem geri alınamaz.
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="flex items-center gap-3 pt-2">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              fullWidth
            >
              İptal
            </Button>
            <Button
              type="button"
              variant="destructive"
              onClick={() => {
                onConfirm(route?.id);
                onClose();
              }}
              fullWidth
              iconName="Trash2"
              iconPosition="left"
            >
              Sil
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;